// Centralized backend URL configuration
export const getBackendUrl = () => {
  // Use env var if set (production builds)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  const origin = window.location.origin;
  // Local dev: frontend on 3000, backend on 8001
  if (origin.includes('localhost:3000')) {
    return 'http://localhost:8001';
  }
  // Production/preview: same origin, ingress routes /api to backend
  return origin;
};

export const BACKEND_URL = getBackendUrl();
